import type { PortfolioUploadType } from "@/src/components/PortfolioScreenshotModal/types";
import { getPortfolioScreenshotUploadedInstruction } from "../errors/errorText";

export type BuildPortfolioScreenshotChatInfoParams = {
  uploadType: PortfolioUploadType;
};

export type PortfolioScreenshotChatInfo = {
  action: "screenshot_recognized" | "pdf_recognized";
  instruction: string;
};

export function buildPortfolioScreenshotChatInfo({
  uploadType,
}: BuildPortfolioScreenshotChatInfoParams): PortfolioScreenshotChatInfo {
  return {
    action: uploadType === "pdf" ? "pdf_recognized" : "screenshot_recognized",
    instruction: getPortfolioScreenshotUploadedInstruction(),
  };
}
